import { ReactElement, useMemo } from 'react';
import { Grid } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { useFormikContext } from 'formik';
import { ResearchFormIcaro } from 'civil-status/view-models/research-form-icaro';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import SelectLogicOperation from 'shell/components/shared/select-choice';
import { listNameOperator } from 'shell/constants/select-choice-operator';
import { FormControl } from '@mui/material';
import { RadioGroup } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import { Radio } from '@mui/material';
import { CodeSubject } from 'civil-status/constants/code-subject-section';

const FormFilter = (): ReactElement => {
  const formContext = useFormikContext<ResearchFormIcaro>();

  const errorTypePerson: boolean = useMemo(() => {
    return Boolean(formContext.errors.typePerson) && Boolean(formContext.touched.typePerson);
  }, [formContext.errors, formContext.touched]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControl component="fieldset" style={{ color: errorTypePerson ? '#d32f2f' : '' }}>
          <RadioGroup
            row
            aria-label="Tipo persona"
            id="typePerson"
            value={formContext.values.typePerson || ''}
            onChange={(event) => {
              formContext.setFieldValue('typePerson', event.target.value);
            }}
          >
            <FormControlLabel value={CodeSubject.INT_NAS} control={<Radio />} label="Nascituro" />
            <FormControlLabel value={CodeSubject.PADRE} control={<Radio />} label="Padre" />
            <FormControlLabel value={CodeSubject.MADRE} control={<Radio />} label="Madre" />
            <FormControlLabel
              value={CodeSubject.DICHIARANTE_PROC_MA}
              control={<Radio />}
              label="Dichiarante"
            />
            <FormControlLabel
              value={CodeSubject.DICHIARANTE_SANIT}
              control={<Radio />}
              label="Sanitario"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          error={formContext.touched?.surname && Boolean(formContext.errors?.surname)}
          helperText={formContext.errors?.surname}
          id="surname"
          label="Cognome *"
          value={formContext.values?.surname}
          onChange={(event) => {
            formContext.setFieldValue('surname', event.target.value);
          }}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <SelectLogicOperation
          list={listNameOperator}
          value={formContext.values?.surnameOperation || ''}
          id="surname-operator"
          onChange={(event) => {
            formContext.setFieldValue('surnameOperation', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          error={formContext.touched?.name && Boolean(formContext.errors?.name)}
          helperText={formContext.errors?.name}
          id="name"
          label="Nome"
          value={formContext.values?.name}
          onChange={(event) => {
            formContext.setFieldValue('name', event.target.value);
          }}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <SelectLogicOperation
          list={listNameOperator}
          id="name-operator"
          value={formContext.values?.nameOperation || ''}
          onChange={(event) => {
            formContext.setFieldValue('nameOperation', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data nascita"
          aria-label="Data nascita"
          value={formContext.values?.dateBorn || null}
          onChange={(date) => {
            formContext.setFieldValue('dateBorn', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateBorn"
              fullWidth
              error={formContext.touched?.dateBorn && Boolean(formContext.errors?.dateBorn)}
              helperText={formContext.errors?.dateBorn}
            />
          )}
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="space-between" display="flex">
        <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
          <Grid item xs={12} md={2}>
            <PmiButton
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => formContext.resetForm()}
            >
              Pulisci
            </PmiButton>
          </Grid>
          <Grid item xs={12} md={2}>
            <PmiButton variant="contained" color="secondary" fullWidth type="submit">
              Cerca
            </PmiButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Filter Icaro Page - Person - Form component';

export default FormFilter;
